<template>
	<div class="phone_home">
		<pheader :current="1"></pheader>

		
		<img class="banner" :src="getpath('/index/banner','.png')" alt="">

		<div class="bannerpad" :style="{backgroundImage:'url('+ getpath('index/banner_pad','.png') +')'}">
			<img class="bannerinner" :src="getpath('/index/banner_inner','.png')" alt="">
		</div>


		<div class="aboutUummii">
			<p class="atitle">
				<img class="titleline" :src="getpath('/index/title_l','.png')" alt="">
				<img class="titleimg" :src="getpath('/index/title_aboutUummii','.png')" alt="">
			</p>

			<p class="abouttxt">
				Uummii为原创的双语童书和引进的精品中文童书，打造了与之配套且体系化的“童伴榜样”阅读服务，满足中国家庭对中文、英文及双语童书的多样化、多品类的深度阅读需求。
			</p>

		</div>

		<div class="model">
			<p class="atitle">
				<img class="titleline" :src="getpath('/index/title_l','.png')" alt="">
				<img class="titleimg" :src="getpath('/index/title_model','.png')" alt="">
			</p>
			<div class="modelinfo">
				<img class="modelimg" :src="getpath('/index/model01','.png')" alt="">
				<img class="modelimg" :src="getpath('/index/model02','.png')" alt="">
				<img class="modelimg" :src="getpath('/index/model03','.png')" alt="">
				<img class="modelimg" :src="getpath('/index/model04','.png')" alt="">
			</div>

		</div>

		<div class="prodect">
			<img class="title_prodect" :src="getpath('/index/title_prodect','.png')" alt="">
			<img class="title_prodect_pad" :src="getpath('/index/title_prodectpad','.png')" alt="">
			<div class="prodect_list">
				<div class="correct_info">
					<img @click="goto('/correct')" class="correctback" :src="getpath('/index/correct_info','.png?r=1')" alt="">
					<img @click="goto('/correct')"  class="more" :src="getpath('/index/correct_more','.png')" alt="">
					<img @click="gotodown('stick')" class="down" :src="getpath('/index/down_btn','.png')" alt="">
				</div>
				<div class="growup_info">
					<img @click="goto('/growup')" class="correctback" :src="getpath('/index/growup_info','.png')" alt="">
					<img @click="goto('/growup')" class="more" :src="getpath('/index/growup_more','.png')" alt="">
					<img @click="gotodown('growup')" class="down" :src="getpath('/index/down_btn','.png')" alt="">
				</div>
				<div class="stick_info">
					<img @click="goto('/colloquial')" class="correctback" :src="getpath('/index/stick_info','.png')" alt="">
					<img @click="goto('/colloquial')" class="more" :src="getpath('/index/stick_more','.png')" alt="">
					<img @click="gotodown('buy')" class="down" :src="getpath('/index/buy_btn','.png')" alt="">
				</div>
				<!-- <div class="book_info">
					<img class="correctback" :src="getpath('/index/book_info','.png')" alt="">
					<img class="more" :src="getpath('/index/book_more','.png')" alt="">
					<img class="down" :src="getpath('/index/buy_btn','.png')" alt="">
				</div> -->

			</div>
		</div>

		<div class="bot" :style="{backgroundImage:'url('+ getpath('index/bot_back','.png') +')'}">
			<div class="innerbot">
				<div class="point">
					<p class="atitle">
						<img class="titleline" :src="getpath('index/title_l','.png')" alt="">
						<img class="titleimg" :src="getpath('index/title_point','.png?a=01')" alt="">
					</p>
					<div class="pointinfo">
						<img class="pointimg" :src="getpath('index/point01','.png?a=01')" alt="">
						<img class="pointimg" :src="getpath('index/point02','.png?a=01')" alt="">
						<img class="pointimg" :src="getpath('index/point03','.png?a=01')" alt="">
						<img class="pointimg" :src="getpath('index/point04','.png?a=01')" alt="">
						<img class="pointimg" :src="getpath('index/point05','.png?a=01')" alt="">
						<img class="pointimg" :src="getpath('index/point06','.png?a=01')" alt="">
					</div>

				</div>
				<div class="work">
					<p class="atitle">
						<img class="titleline" :src="getpath('/index/title_l','.png')" alt="">
						<img class="titleimg" :src="getpath('/index/title_work','.png')" alt="">
					</p>
					<div class="workbox">
						<div class="workfirst"></div>
						<div class="wookitem">
							<video 
								controls 
								src="https://resource.stagekids.cn/sv/4da266fa-17a863b1d5c/4da266fa-17a863b1d5c.mp4"
								poster="https://resource.stagekids.cn/sv/4da266fa-17a863b1d5c/4da266fa-17a863b1d5c.mp4?spm=a2c4g.11186623.2.1.yjOb8V&x-oss-process=video/snapshot,t_0,f_png,w_0,h_0,m_fast"
							></video>
						</div>
						<div class="wookitem">
							<video
							 controls 
							 src="https://resource.stagekids.cn/sv/47e956e9-178a03bedac/47e956e9-178a03bedac.mp4"
							 poster="https://resource.stagekids.cn/sv/47e956e9-178a03bedac/47e956e9-178a03bedac.mp4?spm=a2c4g.11186623.2.1.yjOb8V&x-oss-process=video/snapshot,t_0,f_png,w_0,h_0,m_fast"
							 >
							 </video>
						</div>
						<div class="wookitem">
							<video 
							controls 
							src="https://resource.stagekids.cn/sv/52d76e36-1813b560ddb/52d76e36-1813b560ddb.mp4"							 
							poster="https://resource.stagekids.cn/sv/52d76e36-1813b560ddb/52d76e36-1813b560ddb.mp4?spm=a2c4g.11186623.2.1.yjOb8V&x-oss-process=video/snapshot,t_0,f_png,w_0,h_0,m_fast"
							>
							</video>
						</div>
						<div class="wookitem">
							<video 
							controls 
							src="https://resource.stagekids.cn/sv/4767d1e2-18133855af5/4767d1e2-18133855af5.mp4"							
							poster="https://resource.stagekids.cn/sv/4767d1e2-18133855af5/4767d1e2-18133855af5.mp4?spm=a2c4g.11186623.2.1.yjOb8V&x-oss-process=video/snapshot,t_0,f_png,w_0,h_0,m_fast"
							>
							</video>
						</div>
						<div class="wookitem">
							<video 
							controls 
							src="https://resource.stagekids.cn/sv/4f549180-17b05ea9458/4f549180-17b05ea9458.mp4"
							poster="https://resource.stagekids.cn/sv/4f549180-17b05ea9458/4f549180-17b05ea9458.mp4?spm=a2c4g.11186623.2.1.yjOb8V&x-oss-process=video/snapshot,t_0,f_png,w_0,h_0,m_fast"
							>
							</video>
						</div>
						<div class="wookitem">
							<video 
							controls 
							src="https://resource.stagekids.cn/sv/55467cab-17a99df555b/55467cab-17a99df555b.mp4"
							poster="https://resource.stagekids.cn/sv/55467cab-17a99df555b/55467cab-17a99df555b.mp4?spm=a2c4g.11186623.2.1.yjOb8V&x-oss-process=video/snapshot,t_0,f_png,w_0,h_0,m_fast"
							>
							
							</video>
						</div>
					</div>

				</div>
				
				<div class="about-module-content">
					<div class="platform">
					<div class="platform-row">
						<img
						@click="jumpUrl('https://weibo.com/u/7701010138')"
						:src="getpath('about/weibo', '.png?ran=2')"
						alt=""
						/>
						<div class="line"></div>
						<img
						@click="jumpUrl('https://www.ximalaya.com/zhubo/275007326')"
						:src="getpath('about/ximalaya', '.png?ran=2')"
						alt=""
						/>
					</div>
					<div class="platform-row">
						<img
						@click="jumpUrl('https://space.bilibili.com/1897648222')"
						:src="getpath('about/bilibili', '.png?ran=2')"
						alt=""
						/>
						<div class="line"></div>
						<img
						@click="
							jumpUrl(
							'https://www.douyin.com/user/MS4wLjABAAAAIK8So74Zs7bvUPZqvZsX24OrsHE36zE17Ezu_V2AtkQ'
							)
						"
						:src="getpath('about/douyin', '.png?ran=2')"
						alt=""
						/>
					</div>
					</div>
					<div class="qr">
					<img :src="getpath('about/publicAccount', '.png?ran=2')" alt="" />
					<img :src="getpath('about/vedioAccount', '.png?ran=2')" alt="" />
					<img :src="getpath('about/service', '.png?ran=2')" alt="" />
					</div>
				</div>
			</div>
			

		</div>



		<pfooter :color="'#206DD4'"></pfooter>

	</div>
</template>

<script>
import netFetch from '@/config/api'
import $ from 'jquery'

import pheader from '../components/header'
import pfooter from '../components/footer'
export default {
	name:'wordinfo',
	components:{pheader,pfooter},
	data() {
		return {
			wordobj:{},
			isvideoend:false,
			player:null,
			isvideo:false,
			isWeiXin:false, // 是否是微信浏览器
			isiphonex:false,
		}
	},
	mounted() {
		document.title = 'Uummii官方网站'
		this.isWeiXin = navigator.userAgent.toLowerCase().indexOf('micromessenger') > -1 ? true : false
	},
	methods: {
		godownload(){
			
			if(!this.isdown){
				netFetch('https://php.uummii.online/api/client/download', 'POST', {
					behavior:2,
					source:5
				}).then(res=>{
					this.isdown = true;
				})
			}
			if(this.isIOS){
				if($(window).height()>1000){
					window.location.href = 'https://apps.apple.com/cn/app/童伴成长pro-儿童阅读启蒙双语绘本/id1603196107';
				}else{
					window.location.href = 'https://apps.apple.com/cn/app/童伴成长-儿童阅读启蒙双语绘本/id1603195715';
				}
			}else{
				// if(this.isWeiXin){
				// 	window.location.href = 'https://a.app.qq.com/o/simple.jsp?pkgname=cn.stagekids.app.wordcorrection.android';
				// }else{
					window.location.href = this.downUrl;
				// }
			}
		},
		jumpUrl(url) {
			window.open(url, "_black");
		},
        goto(path){
            this.jumpInter(path)
        },
		gotobuy(){
			// if(this.isWeiXin){
				window.location.href = 'weixin://dl/business/?t=hY3kHiv3DQl'
			// }else{
			// 	alert('请在微信中打开')
			// }
		}
	},
}
</script>

<style lang="scss" scoped="">
	.phone_home{
		width: 100vw;
		height: 100vh;
		overflow: hidden;
		overflow-y: auto;
		box-sizing: border-box;
		.banner{
			width: 750px;
		}
		.bannerpad{
			width: 100%;
			text-align: center;
			background-size: 100% 100%;
			display: none;
			.bannerinner{
				width: 750px;
				bottom: 0%;
			}
		}
		.atitle{
			width: 100%;
			display: flex;
			flex-flow: row nowrap;
			justify-content: flex-start;
			.titleline{
				width: 10px;
				height: 40px;
			}
			.titleimg{
				height: 40px;
				margin-left: 25px;
			}

		}
		.aboutUummii{
			width: 670px;
			margin: 40px auto 0;
			.abouttxt{
				padding-left: 35px;
				font-size: 26px;
				margin-top: 15px;
			}

		}
		.model{
			width: 670px;
			margin: 40px auto 0;
			.modelinfo{
				display: flex;
				flex-flow: row nowrap;
				justify-content: space-between;
				margin-top: 40px;
				padding-left: 35px;
				.modelimg{
					height: 114px;
				}
			}
		}
		.prodect{
			width: 100%;
			margin-top: 34px;
			display: flex;
    		flex-flow: row wrap;
			position: relative;
			z-index: 2;
			.title_prodect{
				width: 750px;
				height: 200px;
			}
			.title_prodect_pad{
				width: 100%;
				display: none;
			}
			.prodect_list{
				width: 100%;
				min-height: 200px;
				background-color: #3AADFD;
				padding-bottom: 120px;
				margin-top: -2px;
			}
			.more{
				width: 151px;
				height: 43px;
				position: absolute;
				right: 36px;
				top: 28px;
			}
			.down{
				width: 166px;
				height: 55px;
				position: absolute;
				bottom: 41px;
				right: 43px;
			}
			.correct_info{
				width: 722px;
				height: 562px;
				margin: 14px auto 8px;
				position: relative;
				.correctback{
					width: 100%;
					height: 100%;
				}
			}
			.growup_info{
				width: 722px;
				height: 562px;
				margin: 0px auto 8px;
				position: relative;
				.correctback{
					width: 100%;
					height: 100%;
				}
			}
			.stick_info{
				width: 722px;
				height: 562px;
				margin: 0px auto 8px;
				position: relative;
				.correctback{
					width: 100%;
					height: 100%;
				}
			}
			.book_info{
				width: 722px;
				height: 562px;
				margin: 0px auto 8px;
				position: relative;
				.correctback{
					width: 100%;
					height: 100%;
				}
			}
		}
		.bot{
			width: 100%;
			min-height: 1540px;
			margin: 0 auto;
			position: relative;
			background-size: 100%;
			z-index: 5;
			margin-top: -95px;
			box-sizing: border-box;
			padding-top: 73px;
			.innerbot{
				width: 750px;
				margin: 0 auto;
				position: relative;
				
				.point{
					width: 670px;
					margin: 40px auto 0;
					.pointinfo{
						width: 100%;
						height: 383px;
						box-sizing: border-box;
						padding-left: 29px;
						display: flex;
						flex-flow: row wrap;
						justify-content: space-between;
						align-content: space-between;
						margin-top: 36px;
						.pointimg{
							width: 204px;
							height: 182px;
						}
					}
				}
				.work{
					width: 100%;
					margin: 40px auto 0;
					.atitle{
						width: 670px;
						margin: 0 auto;
					}
					.workbox{
						width: 100%;
						height: 400px;
						margin-top: 40px;
						overflow: hidden;
						overflow-x: auto;
						display: flex;
						flex-flow: row nowrap;
						.workfirst{
							width: 80px;
							height: 400px;
							flex-shrink: 0;
						}
						.wookitem{
							width: 225px;
							height: 400px;
							background-color: black;
							flex-shrink: 0;
							margin-right: 26px;
							video{width: 100%;height: 100%;}
						}
					}
					
				}
				.about-module-content {
					width: 670px;
					margin: 20px auto 30px;
					display: flex;
					flex-direction: column;
					align-items: center;
					.platform {
						display: flex;
						flex-wrap: wrap;
						justify-content: center;
						.platform-row {
						margin-top: 32px;
						display: flex;

						img {
							padding-left: 64px;
							padding-right: 64px;
							width: 215px;
							height: 57px;
						}
						.line {
							width: 2px;
							height: 48px;
							background: rgba(0, 0, 0, 1);
						}
						}
					}
					.qr {
						width: 100%;
						display: flex;
						justify-content: space-around;
						margin: 48px 0 52px 0;
						img {
							width: 133px;
							height: 176px;
						}
					}
					img {
						width: 100%;
					}
				}
			}
		}
	}
	@media screen and (min-width: 750px) {
		.phone_home{
			.banner{display: none;}
			.bannerpad{display: block;}
			.prodect{
				.title_prodect{display: none;}
				.title_prodect_pad{display: block;}
			}
		}
	}
</style>


// WEBPACK FOOTER //
// src/page/index.vue